import React, { useState, useEffect } from 'react';
import Input from '../Common/Input';
import Select from '../Common/Select';
import Button from '../Common/Button';
import api from '../../utils/api';
import { useAuth } from '../../contexts/AuthContext';
import { showSuccess, showError } from '../../utils/swal';

const DownPaymentForm = ({ portfolio, onClose, onSuccess }) => {
  const { user } = useAuth();
  const isManager = user?.is_manager || user?.role === 'office_owner';
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [customers, setCustomers] = useState([]);

  const [formData, setFormData] = useState({
    portfolio_id: portfolio?.id || '',
    customer_id: portfolio?.option_type === 'customer' && portfolio?.option_customer_id
      ? portfolio.option_customer_id : '',
    user_id: isManager ? '' : (user?.id || ''),
    date: new Date().toISOString().split('T')[0],
    agreed_price: portfolio?.list_price || '',
    amount_received: '',
  });

  useEffect(() => {
    if (isManager) fetchUsers();
    fetchCustomers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await api.get('/users');
      setUsers(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Kullanıcılar yüklenemedi:', error);
      setUsers([]);
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await api.get('/customers');
      setCustomers(Array.isArray(response.data.data) ? response.data.data : []);
    } catch (error) {
      console.error('Müşteriler yüklenemedi:', error);
      setCustomers([]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post('/down-payments', formData);
      showSuccess('Kapora başarıyla kaydedildi');
      if (onSuccess) onSuccess();
      if (onClose) onClose();
    } catch (error) {
      console.error('Kapora kaydedilemedi:', error);
      if (error.response?.data?.errors) {
        const errors = Object.values(error.response.data.errors).flat();
        showError(errors.join('\n'));
      } else {
        showError(error.response?.data?.message || 'Kapora kaydedilirken bir hata oluştu');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-4">
        <h3 className="font-semibold text-orange-900 mb-1">Kapora Alınacak Gayrimenkul</h3>
        <p className="text-sm text-orange-800">{portfolio?.title}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {isManager ? (
          <Select
            label="İşlemi Yapan Görevli"
            name="user_id"
            value={formData.user_id}
            onChange={handleChange}
            options={users.map(u => ({
              value: u.id,
              label: u.name
            }))}
            required
          />
        ) : (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">İşlemi Yapan Görevli</label>
            <p className="px-3 py-2 bg-gray-100 border border-gray-200 rounded-md text-gray-700">{user?.name}</p>
          </div>
        )}

        <Select
          label="Müşteri"
          name="customer_id"
          value={formData.customer_id}
          onChange={handleChange}
          options={customers.map(customer => ({
            value: customer.id,
            label: `${customer.name} ${customer.surname}`
          }))}
          required
        />

        <Input
          label="Kapora Tarihi"
          name="date"
          type="date"
          value={formData.date}
          onChange={handleChange}
          required
        />

        <Input
          label="Anlaşılan Fiyat"
          name="agreed_price"
          type="number"
          step="0.01"
          value={formData.agreed_price}
          onChange={handleChange}
          required
        />

        <Input
          label="Alınan Kapora"
          name="amount_received"
          type="number"
          step="0.01"
          value={formData.amount_received}
          onChange={handleChange}
          required
        />
      </div>

      <div className="flex gap-2 justify-end pt-4 border-t">
        <Button
          type="button"
          variant="secondary"
          onClick={onClose}
        >
          İptal
        </Button>
        <Button
          type="submit"
          disabled={loading}
        >
          {loading ? 'Kaydediliyor...' : 'Kapora Kaydet'}
        </Button>
      </div>
    </form>
  );
};

export default DownPaymentForm;
